import React from 'react';
import Page from '../components/Page';
import {
  Card,
  CardBody,
  Modal,
  Row, Col,
  Button,
  Table
} from 'reactstrap';
import { MdDone, MdClear, MdCheck, MdClose } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import axios from 'axios';
import moment from 'moment-timezone';
import StorageService from '../services/StorageService';
import PosLicensingTable from '../components/PosLicensingTable';
import PosLicensingBillingForm from '../components/PosLicensingBillingForm';
import PosLicensingBillingFormSchedule from '../components/PosLicensingBillingFormSchedule';
import TableActionButton from '../components/TableActionButton';
import { TextWidget } from '../components/Widget'
//import { datatype } from 'faker';
import Switch from "react-switch";
import { MDBDataTable } from 'mdbreact';

class PosLicensingBillingPage extends React.Component {
    _isMounted = true
    state = {
        list: [],
        isEdit: false,
        modal: false,
        modal2:false,
        editItem: null,
        billing: null,
        company_name: '',
        company_address: ''
    };

    toggle = (action, id) => () => {
        let obj = null;

        if (id !== undefined || id !== null) {
            obj = this.state.list.find(e => e.id == id);
        }

        return this.setState({
            modal: !this.state.modal,
            isEdit: action === 'ADD' ? false : true,
            editItem: obj
        });
    };

    toggle2 = (action, id) => () => {
        return this.setState({
            modal2: !this.state.modal2
        });
    };

    create = data => {
        const user = StorageService.getSession('user_info');
        const url = process.env.REACT_APP_UNITY_API2_URL;
        const formData = {
          session_key: process.env.REACT_APP_UNITY_API2_KEY,
          company_id: this.props.match.params.id,
          company_name: this.state.company_name,
          company_address: this.state.company_address,
          order_id: this.generateId(),
          currency: data.currency,
          amount: data.amount,
          description: data.description,
          billing_date: data.billing_date,
          due_date: data.due_date,
          admin_email: data.admin_email,
          payment_status: data.payment_status,
          created_by: user.email
        };
    
        axios
          .post(url + ':3000/v2/user/billing/create', formData)
          .then(response => {
            const result = response.data;
            if (result.error == true) {
              this.notificationSystem.addNotification({
                title: <MdClear />,
                message: result.message,
                level: 'error',
                position: 'br',
                autoDismiss: 4,
                dismissible: 'click',
              });
              return;
            }
    
            this.setState({
              modal: false,
              isEdit: false,
              editItem: null
            });
    
            this.notificationSystem.addNotification({
              title: <MdDone />,
              message: 'Billing created successfully.',
              level: 'success',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            });
            this.get();
          })
          .catch(error => {
            alert(error);
          });
    };

    update = data => {
        if (window.confirm("Do you really want to save changes?")) {
            const user = StorageService.getSession('user_info');
            const url = process.env.REACT_APP_UNITY_API2_URL;
            const formData = {
            session_key: process.env.REACT_APP_UNITY_API2_KEY,
            id: data.id,
            currency: data.currency,
            amount: data.amount,
            description: data.description,
            billing_date: data.billing_date,
            due_date: data.due_date,
            admin_email: data.admin_email,
            payment_status: data.payment_status,
            update_by: user.email
            };
        
            axios
            .post(url + ':3000/v1/user/billing/update', formData)
            .then(response => {
                const result = response.data;
                if (result.error == true) {
                this.notificationSystem.addNotification({
                    title: <MdClear />,
                    message: result.message,
                    level: 'error',
                    position: 'br',
                    autoDismiss: 4,
                    dismissible: 'click',
                });
                return;
                }
        
                this.setState({
                modal: false,
                isEdit: false,
                editItem: null
                });
        
                this.notificationSystem.addNotification({
                title: <MdDone />,
                message: 'Billing updated successfully.',
                level: 'success',
                position: 'br',
                autoDismiss: 4,
                dismissible: 'click',
                });
                this.get();
            })
            .catch(error => {
                alert(error);
            });
        }
    };

    delete = (id) => {
        if (window.confirm("Do you really want to delete?"))  {
            const user = StorageService.getSession('user_info');
            const url = process.env.REACT_APP_UNITY_API2_URL;
        
            const data = {
            session_key: process.env.REACT_APP_UNITY_API2_KEY,
            id: id,
            delete_by: user.email
            };
        
            axios
            .post(url + ':3000/v1/user/billing/delete', data)
            .then(response => {
                const result = response.data;
        
                if (result.error == 'true' && result.message != 'Success') {
                alert(result.message);
                return;
                }
        
                this.setState({
                    modal: false,
                    isEdit: false,
                    editItem: null
                });
        
                this.notificationSystem.addNotification({
                    title: <MdDone />,
                    message: 'Billing deleted successfully.',
                    level: 'success',
                    position: 'br',
                    autoDismiss: 4,
                    dismissible: 'click',
                });
        
                this.get();
            })
            .catch(error => {
                alert(error);
            });
        }
        
    };

    get = () => {
        const user = StorageService.getSession('user_info');
        const url = process.env.REACT_APP_UNITY_API2_URL;

        const data = {
        session_key: process.env.REACT_APP_UNITY_API2_KEY,
        company_id: this.props.match.params.id
        };

        axios
        .post(url + ':3000/v1/user/billing', data)
        .then(response => {
            const result = response.data;

            if (result.error == 'true' && result.message != 'Success') {
            alert(result.message);
            return;
            }
            for(let i of result.data) {
                i.action = <div className='d-flex'>
                    <Button className="theme-button theme-button-secondary mr-2" onClick={this.toggle('EDIT', i.id)}>Edit</Button>
                    <Button className="theme-button theme-button-primary-light mr-2" onClick={() => this.delete(i.id)}>Delete</Button>
                </div>
            }
            if (this._isMounted) {
                this.setState({ list: result.data});
            }
        })
        .catch(error => {
            alert(error);
        });
    };

    edit = () => {
        const url = process.env.REACT_APP_UNITY_API2_URL;

        const data = {
            session_key: process.env.REACT_APP_UNITY_API2_KEY,
            company_id: this.props.match.params.id
        };

        axios
        .post(url + ':3001/v2/license/detail', data)
        .then(response => {
            const result = response.data;

            if (result.error == 'true' && result.message != 'Success') {
                alert(result.message);
                return;
            }
            
            this.setState({ billing: result.data });
        })
        .catch(error => {
            alert(error);
        });
    };

    editCompany = () => {
        const user = StorageService.getSession('user_info');
        const url = process.env.REACT_APP_API_URL;

        const data = {
            session_key: user.session_key,
            CompanyID: this.props.match.params.id,
        };

        axios
        .post(url + ':3000/v1/company/edit', data)
        .then(response => {
            const result = response.data;

            if (result.error == true && result.message != 'Success') {
                alert(result.message);
                return;
            }

            this.setState({ company_name: result.data.CompanyName, company_address: result.data.CompanyAddress });
        })
        .catch(error => {
            console.log(error)
        });
    };

    generateId() {
        const month = moment().month() + 1;
        const year = moment().year();
        var randomStr           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < 8; i++ ) {
            randomStr += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return `US-${year.toString().slice(-2)}${month < 10 ? '0'+ month : month}-${randomStr}`
    };

    componentDidMount() {
        this.get();
        this.edit();
        this.editCompany();
    }

    componentWillUnmount() {
        this._isMounted = false
    }

  render() {
    return (
      <Page
        title="Billing"
        breadcrumbs={[{ name: 'POS Licensing', active: false }, { name: 'Billing', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <Card>
          <CardBody>
            {this.state.billing && 
                <Table style={{fontSize: '0.85rem'}} size="sm" bordered>
                    <tbody>
                        <tr><th>POS Licensing ({this.state.company_name})</th><td colSpan="3">{this.state.billing.disable > 0 ? 'Disabled' : 'Enabled'}</td></tr>
                        <tr><th>Billing Type</th><td>{this.state.billing.billing_type}</td><th>Plan</th><td>{this.state.billing.plan}</td></tr>
                        <tr>
                            <th>Amount</th>
                            <td>{this.state.billing.billing_amt}</td>
                            <td colSpan="2">
                                <div align="right">
                                    <Button className="theme-button theme-button-primary" onClick={this.toggle('ADD', null)}>Create</Button>
                                    <Button className="theme-button theme-button-primary" onClick={this.toggle2()}>Schedule</Button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            }
            <MDBDataTable data={{
                columns: [
                    {
                        label: 'ID',
                        field: 'order_id',
                        sort: 'asc',
                    },
                    {
                        label: 'Status',
                        field: 'payment_status',
                        sort: 'asc',
                    },
                    {
                        label: 'Billing Date',
                        field: 'billing_date',
                        sort: 'asc',
                    },
                    {
                        label: 'Due Date',
                        field: 'due_date',
                        sort: 'asc',
                    },
                    {
                        label: 'Amount',
                        field: 'amount',
                        sort: 'asc',
                    },
                    {
                        label: 'Currency',
                        field: 'currency',
                        sort: 'asc',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        sort: 'asc',
                    },
                    {
                        label: 'Admin',
                        field: 'admin_email',
                        sort: 'asc',
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sort: 'disabled',
                    },
                ],
                rows: this.state.list.slice().sort((a,b) => {return new Date(b.billing_date)-new Date(a.billing_date);})
            }}
                responsive
                searching={false}
                order={['order_id', 'asc']}
                displayEntries={false}
                entries={20}
                noBottomColumns
                noRecordsFoundLabel="No records"
                pagesAmount={5}
                paginationLabel={["<", ">"]}
                disableRetreatAfterSorting
            />
          </CardBody>
        </Card>

        <Modal isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          centered>
          <PosLicensingBillingForm
            isEdit={this.state.isEdit}
            item={this.state.editItem}
            company_id={this.props.match.params.id}
            billing={this.state.billing}
            toggle={this.toggle}
            create={this.create}
            update={this.update} />
        </Modal>

        <Modal isOpen={this.state.modal2}
          toggle={this.toggle2}
          className={this.props.className}
          centered>
          <PosLicensingBillingFormSchedule
            isEdit={this.state.isEdit}
            item={this.state.editItem}
            company_id={this.props.match.params.id}
            billing={this.state.billing}
            toggle={this.toggle2}
            create={this.create}
            update={this.update} />
        </Modal>
      </Page>
    );
  }
}
export default PosLicensingBillingPage;
